export const SET_DESTATIS_STATISTICS = "SET_DESTATIS_STATISTICS";
export const SET_CUSTOM_STATISTICS = "SET_CUSTOM_STATISTICS";
export const SET_STATISTICS_LOADING = "SET_STATISTICS_LOADING";